import React from 'react';
import { BarChart2, Shield, TrendingUp, PieChart, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import { TitleCaseH2, TitleCaseH3, TitleCaseP, TitleCaseSpan } from './TitleCase';

const benefits = [
  {
    icon: <TrendingUp className="w-8 h-8 text-[hsl(var(--bronze-gold))]" />,
    title: 'Enhanced Returns',
    description: 'Historically, alternative investments have delivered higher returns than traditional stocks and bonds over the long term.'
  },
  {
    icon: <PieChart className="w-8 h-8 text-[hsl(var(--bronze-gold))]" />,
    title: 'Portfolio Diversification',
    description: 'Low correlation with traditional markets helps reduce overall portfolio risk and volatility.'
  },
  {
    icon: <Shield className="w-8 h-8 text-[hsl(var(--bronze-gold))]" />,
    title: 'Inflation Hedge',
    description: 'Many alternative assets, like real estate and commodities, tend to perform well during inflationary periods.'
  },
  {
    icon: <BarChart2 className="w-8 h-8 text-[hsl(var(--bronze-gold))]" />,
    title: 'Access to Growth Sectors',
    description: 'Invest in high-growth areas like private equity, venture capital, and infrastructure projects.'
  }
];



const WhyAlternativesSection = () => {
  return (
    <section id="why-alternatives" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <TitleCaseH2 className="text-3xl md:text-4xl font-bold text-black mb-4 font-sans">
            Why Consider Alternative Investments?
          </TitleCaseH2>
          <TitleCaseP className="text-lg text-gray-600 max-w-3xl mx-auto">
            Alternative Investments Can Play A Crucial Role In Building A Resilient, High-Performing Portfolio.
          </TitleCaseP>
        </div>



        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-lg p-8 border border-slate-200 hover:border-[hsl(var(--bronze-gold))] transition-colors duration-300 shadow-sm">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-md bg-[hsl(var(--bronze-gold))]/10 flex items-center justify-center">
                    {benefit.icon}
                  </div>
                </div>
                <div className="ml-6">
                  <TitleCaseH3 className="text-lg font-semibold text-[hsl(var(--navy))] mb-2">{benefit.title}</TitleCaseH3>
                  <TitleCaseP className="text-slate-500 leading-relaxed text-base">{benefit.description}</TitleCaseP>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link to="/education/alternative-investments" className="inline-block">
            <Button 
              variant="outline"
              colorScheme="primary"
              className="group inline-flex items-center px-6 py-3 text-base font-medium"
            >
              Learn More About Alternative Investments
              <ChevronRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyAlternativesSection;
